import { useRef, useState } from 'react';
import { getGlossaryWord } from '@pm2/api';
import { useAppContext } from '@provider/app-context';
import { useAwaitBeforePrint } from '@provider/print';
import { xml2ast, allHtmlParsers } from '@utils/ast';
import { asyncTimeout } from '@utils/common';
import { GlossaryDefinition } from './atom.glossary-definition.js';
import { tokens, glossaryContainer } from './page.glossary-words.style.js';
import { jsx } from 'react/jsx-runtime';

function GlossaryWordsPrintPage(props) {
  const ref = useRef(null);
  const portalId = useAppContext(state => state.product?.id);
  const [definitions, setDefinitions] = useState([]);
  useAwaitBeforePrint(ref, async () => {
    if (!portalId) {
      return;
    }
    const definitions = await Promise.all(props.glossaryWords.map(word => getGlossaryWord(portalId, word.meta.glossaryWordId, {
      previewMode: false
    })));
    setDefinitions(definitions.map(it => xml2ast(it, allHtmlParsers, "text/html")));
    await asyncTimeout(100);
  });
  return /*#__PURE__*/jsx("div", {
    ref: ref,
    className: glossaryContainer,
    style: tokens.__override({
      columnCount: props.columnCount
    }),
    children: props.glossaryWords.map((it, index) => /*#__PURE__*/jsx(GlossaryDefinition, {
      glossary: it,
      index: index,
      definition: definitions[index] ?? []
    }, index))
  });
}

export { GlossaryWordsPrintPage };
//# sourceMappingURL=page.glossary-words.js.map
